module.exports = __webpack_public_path__ + "media/images/svg/google-bbce75f8c7f6cd3d1c0db56d81258450.svg";